// About Section
const About = () => {
    return(
        <div className="about">
            <h2>How to Get Started!</h2>
            <p>Plan your week ahead of time with the <strong>Fitness Planner</strong> app! Start by selecting the day of the week, then put in ANY form of excercise ranging from walking to yoga to the gym to outdoor sports, you name it!  Follow it up with the length of time you aim to workout for and you're all set. Afterwards, when the week has ended you can clear the entries and log in your new plans for the week ahead of you. Achieve your goals or strive for a healthy lifetyle!</p>
        </div>
    );
}

export default About;